import { Elements } from '@/components';
import CheckBoxIcon from '@/assets/icons/CheckBox.svg';
import Image from 'next/image';

export interface PricingCardProps {
    title: string;
    description: string;
    price: string;
    priceLabel?: string;
    features: string[];
    className?: string;
    outerClassName?: string;
}

export const PricingCard = ({
    title,
    description,
    price,
    priceLabel = 'PEPM',
    features,
    className = '',
    outerClassName = '',
}: PricingCardProps) => {
    return (
        <div className={`flex w-full ${outerClassName}`.trim()}>
            <div className={`h-full w-full rounded-xl bg-[#FFFFFF29] shadow-[0px_0px_4px_0px_#00000014] ${className}`.trim()}>
                <div className="flex h-full w-full flex-col items-start justify-between gap-3 rounded-xl bg-gray-50 p-6">
                    <div className="flex flex-col items-start justify-start gap-2">
                        <Elements.Title title={title} type="h6" className="text-start text-gray-900" />
                        <Elements.Description description={description} type="medium" className="text-left text-gray-900" />
                    </div>

                    <p className="text-left text-gray-900 text-5xl font-semibold">
                        <span className="text-5xl font-semibold text-primary-700">{price}</span> {priceLabel}
                    </p>

                    <ul className="flex w-full flex-1 flex-col items-start justify-start gap-2">
                        {features.map((feature, index) => (
                            <li key={index} className="flex items-center justify-start gap-2">
                                <Image src={CheckBoxIcon} alt="" width={27} height={27} />
                                <span>{feature}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

